import React from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const BoxedPositionsTableToolbar = ({
  theme,
  search,
  onSearchChange,
  positionCount,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      p: 2,
      borderBottom: `1px solid ${theme.palette.divider}`,
      gap: 2,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
      <TextField
        size="small"
        placeholder="Search positions..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "text.disabled" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          width: 300,
          "& .MuiOutlinedInput-root": {
            borderRadius: 1,
          },
        }}
      />
    </Box>

    <Box sx={{ color: theme.palette.text.secondary, fontSize: "14px" }}>
      {positionCount} positions
    </Box>
  </Box>
);

export default BoxedPositionsTableToolbar;
